import * as React from "react";
import { OptionsObject, useSnackbar } from "notistack";
import { EVENT_ENDPOINT_TIMEOUT, EVENT_TOASTR_NOTIFY } from "../../Events";
import { useHubXSubscribe } from "../../HubX";
import SimpleDialog from "../../components/SimpleDialog";
import DialogContent from "@material-ui/core/DialogContent";

function DialogListener() {
  const [isOpen, setIsOpen] = React.useState(false);
  const doNotify = () => {
    setIsOpen(true);
  };

  useHubXSubscribe(EVENT_ENDPOINT_TIMEOUT, doNotify, true);

  return (
    <SimpleDialog
      draggable={false}
      open={isOpen}
      handleClose={() => setIsOpen(false)}
      title="Atenção"
      maxWidth="md"
      fullWidth
    >
      <DialogContent>
        <div style={{fontSize: 20}}>
        Estamos enfrentando instabilidade ao acessar os dados da instalação. Aguarde ao menos 1
        minuto e atualize o seu navegador.
        </div>
      </DialogContent>
    </SimpleDialog>
  );
}

export default DialogListener;
